// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type { ILocationSearchResult } from '~/misc/location/search/types';
import { ESearchResultType } from '~/misc/location/search/types';

// Models
import { DefaultResource } from '~/misc/resource/default-resource.model';

export class LocationSearchModel extends DefaultResource {
  constructor(protected include: ESearchResultType[], protected endpoint = 'location-search/') {
    super();
  }

  search(
    query: string,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<ILocationSearchResult[]> {
    return this.get<ILocationSearchResult[]>(
      `search/${query}`,
      { include: this.include },
      requestConfig
    );
  }
}
